(function() {
    'use strict';
    /*
     * Copyright (c) 2020 In Hand Health.
     * All rights reserved.
     */

    angular
        .module('ihh-common-web')
        .directive('ihhViewEditCurrency', ihhViewEditCurrency);

    /*
     * A directive for displaying a currency text field in read mode and changing it to a text input in edit mode.
     */
    function ihhViewEditCurrency() {
        return {
            restrict: 'AE',
            transclude: true,
            scope: {
                /*
                 * The currency symbol.
                 */
                currency: '@',

                /*
                 * The number of digits to the right of the decimal place.
                 */
                fractionSize: '@',

                /**
                 * The HTML id to use for the control and label, for accessibility.
                 */
                controlId: '@',

                /**
                 * The text to display as a label.
                 */
                label: '@',

                /**
                 * The text to display as a secondary label.
                 */
                secondaryLabel: '@',

                /**
                 * An expression for determining whether or not to hide the label
                 */
                hideLabel: '=',

                /**
                 * The condition to cause the editable element to focus.
                 */
                focus: '=',

                /**
                 * If set, marks the field as required, and in edit mode displayes a visual cue that the value is required.
                 */
                isRequired: '=',

                /**
                 * If set, configures a min value for the input
                 */
                numberMin: '@',

                /**
                 * If set, configures a max value for the input
                 */
                numberMax: '@',

                /**
                 * The step attribute specifies the legal number intervals for an input element.
                 */
                step: '@',

                /**
                 * The scope variable used to track view and edit mode.
                 */
                editFlag: '=',

                /**
                 * The scope variable used as the model for displaying the text in view mode.
                 */
                model: '=',

                /**
                 * The scope variable used as the model for the input field when in edit mode.
                 */
                modelEdit: '=',

                /**
                 * The scope variable used as the model for the input field default.
                 */
                modelDefault: '=',

                /**
                 * The scope variable used to determine inline style
                 */
                inlineStyle: '=',

                /**
                 * The scope variable used to display help text next to labels.
                 */
                helpText: '@',

                /**
                 * The scope variable used to display help symbols next to labels.
                 */
                helpSymbol: '@',

                /**
                 * If truthy, indicates that a numeric zero value should be considered set and not show the naText in view mode.
                 */
                zeroIsSet: '@',

                /**
                 * The scope variable used to display a different 'N/A' text
                 */
                naText: '@'
            },
            templateUrl: 'view-edit/view-edit-currency.tpl.html',
            link: function(scope /*, elem, attrs*/ ) {
                if (!scope.naText) {
                    scope.naText = 'N/A';
                }

                /**
                 * Returns whether the value is considered set for the purpose of deciding whether or not to show the N/A text.
                 */
                scope.isSet = function(value) {
                    return value || (scope.zeroIsSet && value === 0);
                };
            }
        };
    }
})();